export default function SelectedIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="#BEC8F8" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3536 9.35359L12.7678 14.9394C11.7915 15.9157 10.2086 15.9157 9.23227 14.9394L6.64648 12.3536L7.35359 11.6465L9.93938 14.2323C10.5252 14.8181 11.4749 14.8181 12.0607 14.2323L17.6465 8.64648L18.3536 9.35359Z"
          fill="black"
        />
      </svg>
    </>
  );
}
